export default function Anchor() {
  return {}
}
